/**
 * @fileoverview CSS module for rendering input form elements
 * Provides styles for input fields, labels, suggestions dropdown and containers
 *
 * @example
 * // Usage in component:
 * import styles from './InputRenderer.module.css';
 *
 * <div className={styles.inputContainer}>
 *   <label className={styles.label}>Input Label</label>
 *   <input className={styles.input} type="text" />
 *   <div className={styles.suggestionContainer}>
 *     <div className={styles.suggestion}>Suggestion 1</div>
 *     <div className={`${styles.suggestion} ${styles.activeSuggestion}`}>
 *       Active Suggestion
 *     </div>
 *   </div>
 * </div>
 */


.label {
    display: block;
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.017em;
    text-align: left;
    margin-bottom: 8px;
}

.suggestionContainer {
    position: absolute;
    z-index: 10;
    width: 100%;
    background-color: var(--neutural000);
    border: 1px solid var(--neutural400);
    border-radius: 0.5rem;
    margin-top: 0.5rem;
}

.inputContainer {
    position: relative;
}

.suggestion {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid var(--neutural400);
}

.suggestion:last-of-type {
    border: 0;
}

.activeSuggestion {
    background-color: var(--indigo50);
}

.input {
    font-family: Inter, 'system-ui';
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem 0.75rem;
    width: calc(100% - 1.5rem);
    height: 1.5rem;
    background: #ffffff;
    border: 1px solid var(--neutural400);
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
    border-radius: 12px;

    font-size: 18px;
    font-weight: 400;
    color: var(--gray900);
    transition: all 0.2s ease-in-out;
}

.input::placeholder {
    color: var(--neutural500);
    font-weight: 300;
}

.input:disabled {
    background-color: var(--neutural100);
    border-color: var(--neutural400);
    color: var(--neutural500);
}

.input:not(:disabled):hover {
    border-color: var(--neutural900);
}

.input:not(:disabled):focus,
.input:not(:disabled):active {
    outline: 6px solid var(--indigo300);
    border-color: var(--neutural900);
}

.error {
    outline: 6px solid var(--red300);
    border-color: var(--neutural900);
}

.errorMessage {
    display: block;
    color: var(--red700);
}
